const actionPrefix = "mindmapViewSettings";
const CHANGE_SHOW_IDENTIFIER = `${actionPrefix}:CHANGE_SHOW_IDENTIFIER`;
const CHANGE_SHOW_DATES = `${actionPrefix}CHANGE_SHOW_DATES`;
const CHANGE_SHOW_DURATION = `${actionPrefix}CHANGE_SHOW_DURATION`;
const CHANGE_SHOW_NARRATIVE = `${actionPrefix}CHANGE_SHOW_NARRATIVE`;
const TOGGLE_SHOW_RELATIONSHIP_TYPES = `${actionPrefix}TOGGLE_SHOW_RELATIONSHIP_TYPES`;
const CHANGE_SHOW_BLOCKS = `${actionPrefix}CHANGE_SHOW_BLOCKS`;
const CHANGE_SHOW_BLOCKED_BY = `${actionPrefix}CHANGE_SHOW_BLOCKED_BY`;
const CHANGE_SHOW_IMAGE = `${actionPrefix}CHANGE_SHOW_IMAGE`;
const CHANGE_SHOW_SUMMARY = `${actionPrefix}CHANGE_SHOW_SUMMARY`;
const CHANGE_SHOW_INFO_ICONS = `${actionPrefix}CHANGE_SHOW_INFO_ICONS`;

const CHANGE_SHOW_CONNECTOR_LABELS = `${actionPrefix}CHANGE_SHOW_CONNECTOR_LABELS`;

export const actionTypes = {
  CHANGE_SHOW_IDENTIFIER,
  CHANGE_SHOW_DATES,
  CHANGE_SHOW_DURATION,
  CHANGE_SHOW_NARRATIVE,
  TOGGLE_SHOW_RELATIONSHIP_TYPES,
  CHANGE_SHOW_BLOCKS,
  CHANGE_SHOW_BLOCKED_BY,
  CHANGE_SHOW_IMAGE,
  CHANGE_SHOW_SUMMARY,
  CHANGE_SHOW_INFO_ICONS,
  CHANGE_SHOW_CONNECTOR_LABELS
};

const changeShowIdentifier = show => {
  return {
    type: CHANGE_SHOW_IDENTIFIER,
    show
  };
};

const changeShowDates = show => {
  return {
    type: CHANGE_SHOW_DATES,
    show
  };
};

const changeShowDuration = show => {
  return {
    type: CHANGE_SHOW_DURATION,
    show
  };
};

const changeShowNarrative = show => {
  return {
    type: CHANGE_SHOW_NARRATIVE,
    show
  };
};

const toggleShowRelationshipTypes = typeIds => {
  return {
    type: TOGGLE_SHOW_RELATIONSHIP_TYPES,
    typeIds
  };
};

const changeShowBlocks = show => {
  return {
    type: CHANGE_SHOW_BLOCKS,
    show
  };
};

const changeShowBlockedBy = show => {
  return {
    type: CHANGE_SHOW_BLOCKED_BY,
    show
  };
};

const changeShowImage = show => {
  return {
    type: CHANGE_SHOW_IMAGE,
    show
  };
};

const changeShowSummary = show => {
  return {
    type: CHANGE_SHOW_SUMMARY,
    show
  };
};

const changeShowInfoIcons = show => {
  return {
    type: CHANGE_SHOW_INFO_ICONS,
    show
  };
};

const changeShowConnectorLabels = show => {
  return {
    type: CHANGE_SHOW_CONNECTOR_LABELS,
    show
  };
};

export default {
  changeShowIdentifier,
  changeShowDates,
  changeShowDuration,
  changeShowNarrative,
  toggleShowRelationshipTypes,
  changeShowBlocks,
  changeShowBlockedBy,
  changeShowImage,
  changeShowSummary,
  changeShowInfoIcons,
  changeShowConnectorLabels
};
